// How far ahead an Eduspace booking may be placed.
//
// Per the booking guidelines, classrooms open one month in advance for regular
// users. The Operations Team (Cowork Class Admin) handles the exceptions, so
// they get a longer runway to place bookings on behalf of others.
export const USER_BOOKING_WINDOW_MONTHS = 1;
export const ADMIN_BOOKING_WINDOW_MONTHS = 6;
// Every other module (Makers Lab, Bloomberg, Cowork) — same for all roles.
export const OTHER_MODULES_BOOKING_WINDOW_MONTHS = 3;

// `isEduspace` defaults to true so the Eduspace callers stay unchanged.
export const bookingWindowMonths = (isAdmin, isEduspace = true) =>
    !isEduspace
        ? OTHER_MODULES_BOOKING_WINDOW_MONTHS
        : isAdmin ? ADMIN_BOOKING_WINDOW_MONTHS : USER_BOOKING_WINDOW_MONTHS;

const midnight = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

/**
 * Last date a booking may be placed on, inclusive.
 *
 * Month arithmetic clamps to the end of the target month, so 31 Jan + 1 month is
 * 28/29 Feb rather than 2/3 Mar (which is what a bare `setMonth` would give).
 */
export const bookingWindowEnd = (isAdmin, from = new Date(), isEduspace = true) => {
    const start = midnight(from);
    const targetMonth = start.getMonth() + bookingWindowMonths(isAdmin, isEduspace);
    const end = new Date(start.getFullYear(), targetMonth, start.getDate());
    // Day-of-month overflowed into the following month -> step back to the last
    // day of the month we actually wanted.
    const wrappedMonth = ((targetMonth % 12) + 12) % 12;
    if (end.getMonth() !== wrappedMonth) end.setDate(0);
    return end;
};

/** True when `date` (Date or 'YYYY-MM-DD') falls past the bookable window. */
export const isBeyondBookingWindow = (date, isAdmin, from = new Date(), isEduspace = true) => {
    if (!date) return false;
    const d = date instanceof Date ? date : new Date(`${date}T00:00:00`);
    if (Number.isNaN(d.getTime())) return false;
    return midnight(d) > bookingWindowEnd(isAdmin, from, isEduspace);
};

/** Shared copy for the tooltip on a blocked day and the toast on a blocked submit. */
export const bookingWindowMessage = (isAdmin, isEduspace = true) => {
    const months = bookingWindowMonths(isAdmin, isEduspace);
    return `Bookings can only be made up to ${months} month${months === 1 ? "" : "s"} in advance.`;
};
